"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdGeneration = void 0;
const dev_tunnels_contracts_1 = require("@microsoft/dev-tunnels-contracts");
class IdGeneration {
    static generateTunnelId() {
        let tunnelId = "";
        tunnelId += this.adjectives[Math.floor(Math.random() * this.adjectives.length)] + "-";
        tunnelId += this.nouns[Math.floor(Math.random() * this.nouns.length)] + "-";
        for (let i = 0; i < 7; i++) {
            tunnelId += dev_tunnels_contracts_1.TunnelConstraints.oldTunnelIdChars[Math.floor(Math.random() * (dev_tunnels_contracts_1.TunnelConstraints.oldTunnelIdChars.length))];
        }
        return tunnelId;
    }
}
exports.IdGeneration = IdGeneration;
IdGeneration.nouns = ["pond", "hill", "mountain", "field", "fog", "ant", "dog", "cat", "shoe", "plane", "chair", "book", "ocean", "lake", "river", "horse"];
IdGeneration.adjectives = ["fun", "happy", "interesting", "neat", "peaceful", "puzzled", "kind", "joyful", "new", "giant", "sneaky", "quick", "majestic", "jolly", "fancy", "tidy", "swift", "silent", "amusing", "spiffy"];
//# sourceMappingURL=idGeneration.js.map